import styles from './styles.module.css'
import { TextInputField } from '../../entities/TextInputField'
import { SendButton } from '../../entities/SendButton'
import React, { type SyntheticEvent, useCallback, useState } from 'react'
import { PlayerManipulationService } from '../../shared/player/services/player-manipulation-service'
import { TPlayerUpdateResult, type TPlayer, type TPlayerCreationResult } from '../../pages/PlayersPage/types'
import { Alert } from '@mui/material'
import { SelectionMenu } from 'entities/SelectionMenu'
import { TSelectionVariant } from 'entities/SelectionMenu/types'
import { checkingsCreateForm } from './checkingsCreateForm'
import { connect } from 'react-redux'
import { mapDispatchToProps, mapStateToProps } from 'pages/PlayersPage/maps'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PlayerCard } from './ui/playerCard'

const genderTypeSelections = [
  {
    label: 'Мужской',
    value: 'man'
  },
  {
    label: 'Женский',
    value: 'woman'
  }
]

const playerManipulationService = PlayerManipulationService()

export const PlayersCreationForm: any = connect(mapStateToProps, mapDispatchToProps)(function ({
  editablePlayer,
  setEditablePlayer
}: any) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const playerId = searchParams.get('id')
  const [errorMessage, setErrorMessage] = useState('')
  const [resultMessage, setResultMessage] = useState('')

  const [ countryValidationError, setCountryValidationError ] = useState('')
  const [ playerNameValidationError, setPlayerNameValidationError ] = useState('')

  const setEditablePlayerName = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ name: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerBirthDate = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ birthDate: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerCountry = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ country: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerCity = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ city: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerPlays = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ plays: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerWeight = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ weight: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerHeight = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ height: e.currentTarget.value }),
  [setEditablePlayer])

  const setEditablePlayerGender = useCallback(
    (e: TSelectionVariant) =>
      setEditablePlayer({ gender: e.value }),
  [setEditablePlayer])

  const setEditablePlayerInitialRating = useCallback(
    (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setEditablePlayer({ initialRating: Number(e.currentTarget.value) }),
  [setEditablePlayer])

  const setEditablePlayerAvatar = useCallback((e: string) => setEditablePlayer({ avatar: e }),[setEditablePlayer])

  function checkBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return true;
    } else {
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      var newBytes = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
      if (i > 0 && newBytes > 700) {
        setTimeout(() => { setErrorMessage('') }, 5000)
        setErrorMessage(`Размер файла: ${newBytes + ' ' + sizes[i]}; больше допустимого: 700 КБ`);
        return false
      }
      return true;
    }
  }

  const onClickCreate = useCallback(async () => {
    if (playerNameValidationError) {
      setTimeout(() => { setErrorMessage('') }, 5000)
      setErrorMessage(playerNameValidationError);
      return
    }
    if (countryValidationError) {
      setTimeout(() => { setErrorMessage('') }, 5000)
      setErrorMessage("Страна " + countryValidationError);
      return
    }

    const newPlayer: TPlayer = {
      name: editablePlayer.name.trim(),
      country: editablePlayer.country,
      city: editablePlayer.city,
      birthDate: editablePlayer.birthDate,
      height: editablePlayer.height,
      weight: editablePlayer.weight,
      plays: editablePlayer.plays,
      avatar: editablePlayer.avatar,
      initialRating: editablePlayer.initialRating,
      gender: editablePlayer.gender
    }

    const resCheck = checkingsCreateForm(newPlayer)
    if (!!resCheck) {

      setTimeout(() => { setErrorMessage('') }, 5000)
      setErrorMessage(resCheck); return
    }

    const sizePhoto = new Blob([editablePlayer.avatar]).size
    if(!checkBytes(sizePhoto)) {
      return
    }

    if (playerId !== null) {
      const results: TPlayerUpdateResult = await playerManipulationService.updatePlayer({...newPlayer, id: playerId})

      if (results.errorMessage) {
        setTimeout(() => { setErrorMessage('') }, 5000)
        setErrorMessage(results.errorMessage); return
      }
      setTimeout(() => { setResultMessage('') }, 5000)
      setResultMessage('Игрок успешно обновлен')
    } else {
      const results: TPlayerCreationResult = await playerManipulationService.createPlayer(newPlayer)

      if (results.errorMessage) {
        setTimeout(() => { setErrorMessage('') }, 5000)
        setErrorMessage(results.errorMessage); return
      }
      navigate(window.location.search + '?id=' + results.player?.id)
      setTimeout(() => { setResultMessage('') }, 5000)
      setResultMessage('Игрок успешно создан')
    }
    
  }, [editablePlayer, playerNameValidationError, countryValidationError])

  const reader = new FileReader()

  const nameValidation = () => {
    const commonCondition = /^[a-zA-Z\-` ]*/
    const doubleSpaceCondition = /  /

    if(doubleSpaceCondition.test(editablePlayer.name)){
      setPlayerNameValidationError('В имени не должно быть двойных пробелов')
      return false
    }

    if(commonCondition.test(editablePlayer.name)){
      setPlayerNameValidationError('')
      return true
    }
    setPlayerNameValidationError('Только имена на латинице. Разрешены - и ` а так же пробелы')
    return false
  }

  const countryValidation = () => {
    const reg = /^[A-Z]{2}$/
    if(!reg.test(editablePlayer.country)){
      setCountryValidationError('Только двубуквенное обозначение большими латинскими буквами')
      return false
    }
    setCountryValidationError('')
    return true
  }

  return <div className={styles.App}>
    <div className={styles.FlexContainer}>
      <div className={styles.Images}>
        <PlayerCard/>
        <img alt="Добавьте изображение" src={editablePlayer.avatar} style={{
          width: 200,
          objectFit: "cover"
        }}/>
        <input
          className={styles.InputFields}
          type='file'
          id={'input'}
          accept='image/*,.png,.jpg,.gif,.web'
          onChange={(event) => {
            // @ts-expect-error
            reader.readAsDataURL(event.target.files[0])
            reader.onloadend = () => {
              // @ts-expect-error
              setEditablePlayerAvatar(reader.result)
            }
          }}
        />
      </div>
      <div className={styles.Inputs}>
        <TextInputField 
          value={editablePlayer.name || ''} 
          className={styles.InputFields} 
          id={'Name'} 
          label={'Имя игрока'} 
          onChange={setEditablePlayerName} 
          validation={nameValidation}
          errorText={playerNameValidationError}
        />
        <div className={styles.SelectorWrapper}>
          <SelectionMenu 
            selectionVariants={genderTypeSelections} 
            label={'Пол игрока'} 
            onSelect={setEditablePlayerGender}
            selectedValue={editablePlayer.gender}
          />
        </div>
        <TextInputField
          value={editablePlayer.birthDate}
          className={styles.InputFields}
          id={'BirthDate'}
          label={'Дата рождения'}
          type={'date'}
          onChange={setEditablePlayerBirthDate}
        />
          <div className={styles.CountryCityRow}>
            <TextInputField 
              value={editablePlayer.country} 
              className={styles.InputFields} 
              id={'Country'} 
              label={'Страна'} 
              onChange={setEditablePlayerCountry} 
              validation={countryValidation}
              errorText={countryValidationError}
              />
            <TextInputField
              value={editablePlayer.city} 
              className={styles.InputFields}
              id={'City'}
              label={'Город'}
              onChange={setEditablePlayerCity} />
            <TextInputField
              type='number'
              value={String(editablePlayer.initialRating)} 
              className={styles.InputFields}
              id={'InitialRating'}
              label={'Нач. Рейтинг'}
              onChange={setEditablePlayerInitialRating} />
          </div>
          <TextInputField
            value={editablePlayer.plays} 
            className={styles.InputFields}
            id={'Plays'}
            label={'Какой рукой играет? '}
            onChange={setEditablePlayerPlays} />
          <div className={styles.WeightHeightRow}>
              <TextInputField
                value={editablePlayer.weight} 
                className={styles.InputFields} 
                id={'Weight'}
                label={'Вес'}
                onChange={setEditablePlayerWeight} />
              <TextInputField
                value={editablePlayer.height} 
                className={styles.InputFields}
                id={'Height'}
                label={'Рост'}
                onChange={setEditablePlayerHeight} />
          </div>
      </div>
    </div>
    
  
        
    <div className={styles.WeightHeightRow}>
        <SendButton className={styles.InputFields} label={'Очистить'} onClick={() => {}} />
        <SendButton className={styles.InputFields} label={playerId !== null ? 'Обновить' : 'Создать'} onClick={onClickCreate} />
    </div>
    {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
    {resultMessage && <Alert severity="success">{resultMessage}</Alert>}
  </div>
})
